{
  "overridesEnabledBadgeLabel": "Sostituzioni attive",
  "releaseBadgeAlpha": "Alfa",
  "releaseBadgeBeta": "Beta",
  "releaseBadgeDev": "Dev",
  "releaseBadgePoc": "PoC"
}
